import { cn } from "@/lib/utils";

interface SettingsRowProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}

export function SettingsRow({
  title,
  description,
  children,
  className,
}: SettingsRowProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between border-b border-border py-4 last:border-0",
        className
      )}
    >
      <div>
        <div className="text-sm font-medium">{title}</div>
        <div className="text-sm text-muted-foreground">{description}</div>
      </div>
      {children}
    </div>
  );
}
